import Image from "next/image";
import { useRouter } from "next/router";
import Link from "next/link";
import { useMediaQuery } from "react-responsive";
import { useRegisterTrack } from "@/states/user.state";
import classes from "./Header.module.scss";
import { useLocale, useTranslations } from "next-intl";
import { LocaleLang } from "@/constant";
interface Props {
  shadow?: string;
}
const Header = ({
  shadow
}: Props) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 768px)"
  });
  const {
    pathname
  } = useRouter();
  const l = useLocale();
  const t = useTranslations("Header");
  const {
    setRegisterTrack
  } = useRegisterTrack();
  const handleRegisterTrack = () => {
    setRegisterTrack(pathname);
  };
  const renderLogo = () => {
    const logoSrc = l === LocaleLang.nl ? "/common/logo-nl.svg" : "/common/logoHeader.svg";
    const logoAlt = t("logoAlt");
    return <Image priority src={logoSrc} alt={logoAlt || "qr generator"} width={265} height={41} data-sentry-element="Image" data-sentry-component="renderLogo" data-sentry-source-file="Header.tsx" />;
  };
  return <div className={classes.wrapper} data-sentry-component="Header" data-sentry-source-file="Header.tsx">
      <div className={classes.header} style={{
      boxShadow: shadow
    }}>
        <div className={classes.header__container}>
          <div className={classes.header__flexBox}>
            <div className={classes.header__left}>
              <div className={classes.header__logo}>
                <Link href={"/"} data-sentry-element="Link" data-sentry-source-file="Header.tsx">{renderLogo()}</Link>
              </div>
            </div>
            <div className={classes.header__right}>
              <div className={classes.header__linkBox}>
                <Link href={"/login"} className={classes.header__login} data-sentry-element="Link" data-sentry-source-file="Header.tsx">
                  {t("login")}
                </Link>
                <Link href={"/register"} data-sentry-element="Link" data-sentry-source-file="Header.tsx">
                  <button className={classes.header__trial} onClick={handleRegisterTrack}>
                    {t("signUp")}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Header;